let $selects;

function cacheDOM() {
  $selects = document.querySelectorAll('.js-filter-select');
}

function createSelect($select) {
  $select.addEventListener('change', () => {
    if ($select.value) {
      window.location = $select.value;
    }
  });
}

export default function init() {
  cacheDOM();
  if ($selects && $selects.length) {
    $selects.forEach(createSelect);
  }
}
